import React, { useContext, useState, useEffect, useRef } from "react";
import { db, serverTime } from "../Utils/firebase";

import { CgArrowUp, CgClose, CgPen } from "react-icons/cg";

import { AuthContext } from "../context/AuthContext";

function MyLink({ list }) {
  const [alert, setAlert] = useState(false);
  const [modal, setModal] = useState(false);
  const { userData, userAuth, setUserData, click, visitor } = useContext(
    AuthContext
  );
  const [loading, setLoading] = useState(false);
  const [btnText, setBtntext] = useState("Remove All");
  const [btnPos, setBtnpos] = useState("Save Position");
  const [mount, setMount] = useState(true);
  const [params, setParams] = useState(null);
  const [tempedit, setTempedit] = useState(null);
  const [description, setDescription] = useState("");
  const [section, setSection] = useState("");
  const [error, setError] = useState(null);
  const [mylink, setMylink] = useState([]);
  const [isdif, setIsdif] = useState(false);

  const textDesc = useRef();

  const limitChar = (e) => {
    if (
      e.target.value.length > e.target.maxLength &&
      e.keyCode !== 46 &&
      e.keyCode !== 8
    ) {
      e.preventDefault();
    }
  };

  const removeAll = () => {
    setLoading(true);
    setBtntext("Removing ...");
    closeAlert();
    db.collection("user")
      .doc(userAuth.uid)
      .update({
        link: [],
        updateAt: serverTime,
      })
      .then(() => {
        db.collection("user")
          .doc(userAuth.uid)
          .get()
          .then((doc) => {
            setUserData(doc.data());
            if (mount) {
              setLoading(false);
              setBtntext("Remove All");
              setParams(null);
            }
          })
          .catch((error) => {
            if (mount) {
              setError(error.code);
              setLoading(false);
              setBtntext("Remove All");
              setParams(null);
            }
          });
      })
      .catch((error) => {
        if (mount) {
          setError(error.code);
          setLoading(false);
          setBtntext("Remove All");
          setParams(null);
        }
      });
  };

  const removeItem = () => {
    if (params) {
      setLoading(true);
      closeAlert();
      setBtntext("Removing ...");
      db.collection("user")
        .doc(userAuth.uid)
        .get()
        .then((doc) => {
          const currentLink = doc.data().link;
          const newLink = currentLink.filter((l) => params !== l.id);
          db.collection("user")
            .doc(userAuth.uid)
            .update({
              link: newLink,
              updateAt: serverTime,
            })
            .then(() => {
              db.collection("user")
                .doc(userAuth.uid)
                .get()
                .then((doc) => {
                  setUserData(doc.data());
                  setMylink(doc.data().link);
                  setLoading(false);
                  setBtntext("Remove All");
                  setParams(null);
                })
                .catch((error) => {
                  if (mount) {
                    setError(error.code);
                    setLoading(false);
                    setBtntext("Remove All");
                    setParams(null);
                  }
                });
            })
            .catch((error) => {
              if (mount) {
                setError(error.code);
                setLoading(false);
                setBtntext("Remove All");
                setParams(null);
              }
            });
        })
        .catch((error) => {
          if (mount) {
            setError(error.code);
            setLoading(false);
            setBtntext("Remove All");
            setParams(null);
          }
        });
    }
  };

  const openAlert = (id) => {
    setAlert(true);
    setParams(id);
    document.body.style.overflow = "hidden";
  };
  const closeAlert = () => {
    setAlert(false);
    document.body.style.removeProperty("overflow");
  };

  const buttonChoose = () => {
    if (params !== "") {
      if (params === "removeAll") {
        return <button onClick={removeAll}>Yes</button>;
      } else {
        return <button onClick={removeItem}>Yes</button>;
      }
    }
  };

  useEffect(() => {
    if (userData.link.length >= 1) {
      setMylink(userData.link);
    } else {
      setMylink([]);
    }
  }, [userData]);

  const upPosition = (arr, old_index, new_index) => {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  useEffect(() => {
    if (JSON.stringify(mylink) === JSON.stringify(userData.link)) {
      setIsdif(false);
    } else {
      setIsdif(true);
    }
  }, [mylink, userData]);

  const cancelPosition = () => {
    setMylink(userData.link);
    setIsdif(false);
  };

  const savePosition = () => {
    setLoading(true);
    setBtnpos("Saving Position ...");

    db.collection("user")
      .doc(userAuth.uid)
      .update({
        link: mylink,
        updateAt: serverTime,
      })
      .then(() => {
        db.collection("user")
          .doc(userAuth.uid)
          .get()
          .then((doc) => {
            setUserData(doc.data());
            setLoading(false);
            setBtnpos("Save Position");
          })
          .catch((error) => {
            if (mount) {
              setError(error.message);
              setLoading(false);
              setBtnpos("Save Position");
            }
          });
      })
      .catch((error) => {
        if (mount) {
          setError(error.message);
          setLoading(false);
          setBtnpos("Save Position");
        }
      });
  };

  useEffect(() => {
    if (modal) {
      textDesc.current.focus();
    }
  }, [modal]);

  const openModal = (item) => {
    setModal(true);
    setTempedit(item);
    setDescription(item.description);
    setSection(item.section);

    document.body.style.overflow = "hidden";
  };
  const closeModal = () => {
    setModal(false);
    setTempedit(null);
    setDescription("");
    setSection("");
    setError(null);
    document.body.style.removeProperty("overflow");
  };

  const setDescript = (e) => {
    let desc = e.target.value;
    setDescription(desc.trim().toString());
  };
  const setDatasection = (e) => {
    let text = e.target.value;
    setSection(text.trim().toString());
  };

  const editLink = () => {
    setError(null);
    setLoading(true);
    const newData = mylink.map((i) => {
      if (i.id === tempedit.id) {
        return {
          id: i.id,
          url: i.url,
          description: description.trim().toString(),
          section: section !== "" ? section.trim().toString() : "",
          create_at: i.create_at,
        };
      }
      return i;
    });

    if (
      description.toString() !== tempedit.description.toString() ||
      section.toString() !== tempedit.section.toString()
    ) {
      if (description !== "") {
        db.collection("user")
          .doc(userAuth.uid)
          .update({
            link: newData,
            updateAt: serverTime,
          })
          .then(() => {
            db.collection("user")
              .doc(userAuth.uid)
              .get()
              .then((doc) => {
                setUserData(doc.data());
                if (mount) {
                  setLoading(false);
                  closeModal();
                }
              })
              .catch((error) => {
                if (mount) {
                  setError(error.code);
                  setLoading(false);
                }
              });
          })
          .catch((error) => {
            if (mount) {
              setError(error.code);
              setLoading(false);
            }
          });
      } else {
        textDesc.current.focus();
        setLoading(false);
        setError("Data Cannot be empty!");
      }
    } else {
      setLoading(false);
      closeModal();
    }
  };

  const handlePosition = (old_index) => {
    let new_index = old_index - 1;
    let array_current = mylink.map((l) => l);
    const newArray = upPosition(array_current, old_index, new_index);
    setMylink(newArray);
  };

  const getNumberClick = (id) => {
    if (click !== null) {
      const number = click.filter((cl) => cl.id_link === id);
      if (number.length <= 0) {
        return (
          <>
            <b>0</b> Click{" "}
          </>
        );
      } else {
        if (number.length > 1) {
          return (
            <>
              <b>{new Intl.NumberFormat().format(number.length)}</b> Clicks{" "}
            </>
          );
        } else {
          return (
            <>
              <b>{number.length}</b> Click{" "}
            </>
          );
        }
      }
    } else {
      return (
        <>
          <b>0</b> Click{" "}
        </>
      );
    }
  };

  const getCTR = (time, id) => {
    if (visitor !== null) {
      if (time !== undefined) {
        const create_at = time.toDate().getTime();
        const visit = visitor.filter(
          (vis) => vis.visit_at.toDate().getTime() > create_at
        );
        const number_click = click.filter(
          (cl) =>
            cl.id_link === id && cl.click_at.toDate().getTime() > create_at
        );
        if (number_click.length <= 0) {
          return "0% CTR";
        } else {
          const CTR = (number_click.length / visit.length) * 100;
          return CTR.toFixed(2) + "% CTR";
        }
      } else {
        return "0% CTR";
      }
    } else {
      return "0% CTR";
    }
  };

  useEffect(() => {
    return () => {
      setMount(false);
    };
  }, []);

  return (
    <>
      <div className="all-link divContent darktextColor darkdivColor">
        {alert && (
          <div className="alert">
            <div className="alert-box">
              <h5>Delete this link?</h5>
              <p>This action cannot be undone!</p>
              <div className="option-wrap">
                {buttonChoose()}
                <button onClick={closeAlert}>Cancel</button>
              </div>
            </div>
          </div>
        )}
        {modal && (
          <div className="modal">
            <div className="modal-box">
              <h5>Edit :</h5>
              <form>
                <div className="grup-input">
                  <label>
                    <span className="text">Description : </span>
                    <input
                      className="input-1"
                      type="text"
                      name="edit-desctiption"
                      maxLength={48}
                      onKeyDown={limitChar}
                      onKeyUp={limitChar}
                      onKeyPress={limitChar}
                      onChange={setDescript}
                      defaultValue={tempedit && tempedit.description}
                      placeholder="Example : `My YouTube Channel`"
                      disabled={loading}
                      ref={textDesc}
                    />
                  </label>
                </div>
                <div className="grup-input">
                  <label>
                    <span className="text">Section : </span>
                    <input
                      list="sections"
                      className="input-1"
                      name="description"
                      id="description"
                      maxLength={32}
                      onKeyDown={limitChar}
                      onKeyUp={limitChar}
                      onKeyPress={limitChar}
                      onChange={setDatasection}
                      placeholder="Leave it Empty (All Link)"
                      disabled={loading}
                      defaultValue={tempedit && tempedit.section}
                    />
                    <datalist id="sections">
                      {list.map((item, index) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </datalist>
                  </label>
                </div>
              </form>

              <div className="option-wrap">
                {loading ? (
                  <button disabled={true}>Saving ...</button>
                ) : (
                  <>
                    <button onClick={editLink}>Save</button>
                    <button onClick={closeModal}>Cancel</button>
                  </>
                )}
              </div>

              {error ? (
                <div className="error">
                  <p className="text">
                    <b>{error}</b>
                  </p>
                  <br />
                </div>
              ) : null}
            </div>
          </div>
        )}
        <div className="head-tab">
          <h5 className="textTitle textMedium">My Link</h5>
          {!isdif ? (
            <p className="text textMedium">{mylink.length} / 15</p>
          ) : (
            <>
              {!loading && (
                <span
                  className="canPos text textMedium"
                  onClick={cancelPosition}
                >
                  Cancel
                </span>
              )}
            </>
          )}
        </div>
        <div className="box-links">
          {mylink.length ? (
            mylink.map((l, index) => {
              return (
                <div className="link" key={l.id}>
                  <div className="head-link">
                    <div className="left-head">
                      {isdif ? (
                        <CgPen
                          size="1em"
                          title="Loading ..."
                          className="icon-edit edit-disable"
                        />
                      ) : (
                        <>
                          {!loading ? (
                            <>
                              <CgPen
                                size="1em"
                                title="Edit Description"
                                className="icon-edit"
                                onClick={() => openModal(l)}
                              />
                            </>
                          ) : (
                            <CgPen
                              size="1em"
                              title="Loading ..."
                              className="icon-edit edit-disable"
                            />
                          )}
                        </>
                      )}
                      <span className="darktextColor textSmall">
                        {getNumberClick(l.id)} / {getCTR(l.create_at, l.id)}
                      </span>
                    </div>

                    {isdif ? null : (
                      <>
                        {!loading ? (
                          <>
                            <CgClose
                              size="1.2em"
                              title="Delete this link"
                              className="icon-delete"
                              onClick={() => openAlert(l.id)}
                            />
                          </>
                        ) : (
                          <>
                            {params === l.id ? (
                              <span className="textSmall">removing ...</span>
                            ) : null}
                          </>
                        )}
                      </>
                    )}
                  </div>

                  <div className="url-link">
                    <input
                      type="text"
                      className="input-1 disable-text"
                      name="url"
                      onClick={(e) => e.target.blur()}
                      onChange={(e) => e.preventDefault()}
                      onInput={(e) => e.preventDefault()}
                      onKeyDown={(e) => e.preventDefault()}
                      onSelect={(e) => e.preventDefault()}
                      defaultValue={l.url}
                      disabled={true}
                    />
                  </div>
                  <div className="head-link">
                    <h5 className="text textNormal">{l.description}</h5>
                    {!loading ? (
                      <>
                        {index > 0 ? (
                          <>
                            <CgArrowUp
                              size="1.2em"
                              title="Up Position"
                              className="icon-arrow"
                              onClick={() => handlePosition(index, l.site)}
                            />
                          </>
                        ) : null}
                      </>
                    ) : null}
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text">There is no links</p>
          )}
        </div>
        {isdif ? (
          <>
            <button
              className={
                loading
                  ? "btn-in darktextColor textTitle disable"
                  : "btn-in darktextColor textTitle "
              }
              onClick={savePosition}
              disabled={loading}
            >
              {btnPos}
            </button>
          </>
        ) : (
          <>
            {mylink.length > 1 ? (
              <button
                className={
                  loading
                    ? "btn-in darktextColor textTitle disable"
                    : "btn-in darktextColor textTitle "
                }
                onClick={() => openAlert("removeAll")}
                disabled={loading}
              >
                {btnText}
              </button>
            ) : null}
          </>
        )}

        {error ? (
          <div className="error">
            <p className="text">{error}</p>
          </div>
        ) : null}
      </div>
    </>
  );
}

export default MyLink;
